import { put, takeLeading } from 'redux-saga/effects';

import bookingReviewApi from 'api/bookingReviewApi';
import { apiErrorHandler, showSuccess } from 'utils';

import {
// GET BOOKING REVIEW LIST
  GET_BOOKING_REVIEW_LIST,
  GET_BOOKING_REVIEW_LIST_SUCCESS,
  GET_BOOKING_REVIEW_LIST_FAILED,

  // GET REVIEW OVERVIEW OF BOOKING REVIEW
  GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW,
  GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_SUCCESS,
  GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_FAILED,

  // GET BOOKING REVIEW DETAIL
  GET_BOOKING_REVIEW_DETAIL,
  GET_BOOKING_REVIEW_DETAIL_SUCCESS,
  GET_BOOKING_REVIEW_DETAIL_FAILED,

  // POST FEEDBACK BOOKING REVIEW
  POST_FEEDBACK_BOOKING_REVIEW,
  POST_FEEDBACK_BOOKING_REVIEW_SUCCESS,
  POST_FEEDBACK_BOOKING_REVIEW_FAILED,

  // UPDATE BOOKING REVIEW (INTRANET)
  UPDATE_BOOKING_REVIEW,
  UPDATE_BOOKING_REVIEW_SUCCESS,
  UPDATE_BOOKING_REVIEW_FAILED,

  // DELETE BOOKING REVIEW (INTRANET)
  DELETE_BOOKING_REVIEW,
  DELETE_BOOKING_REVIEW_SUCCESS,
  DELETE_BOOKING_REVIEW_FAILED,

  // UPDATE FEEDBACK BOOKING REVIEW
  UPDATE_FEEDBACK_BOOKING_REVIEW,
  UPDATE_FEEDBACK_BOOKING_REVIEW_SUCCESS,
  UPDATE_FEEDBACK_BOOKING_REVIEW_FAILED,

  // DELETE FEEDBACK BOOKING REVIEW
  DELETE_FEEDBACK_BOOKING_REVIEW,
  DELETE_FEEDBACK_BOOKING_REVIEW_SUCCESS,
  DELETE_FEEDBACK_BOOKING_REVIEW_FAILED,
} from './actionTypes';

function* getBookingReviewList({ payload }) {
  try {
    const response = yield bookingReviewApi.getBookingReviewList(payload);

    yield put({
      type: GET_BOOKING_REVIEW_LIST_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_BOOKING_REVIEW_LIST_FAILED,
    });
  }
}

function* getReviewOverviewOfBookingReview({ payload }) {
  try {
    const response = yield bookingReviewApi.getReviewOverviewOfBookingReview(payload);

    yield put({
      type: GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_FAILED,
    });
  }
}

function* getBookingReviewDetail({ payload }) {
  try {
    const response = yield bookingReviewApi.getBookingReviewDetail(payload.reviewId);

    yield put({
      type: GET_BOOKING_REVIEW_DETAIL_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_BOOKING_REVIEW_DETAIL_FAILED,
    });
  }
}

function* postFeedbackBookingReview({ payload }) {
  try {
    yield bookingReviewApi.postFeedbackBookingReview(payload);

    yield put({
      type: POST_FEEDBACK_BOOKING_REVIEW_SUCCESS,
    });

    showSuccess('Phản hồi đánh giá thành công');

    yield put({
      type: GET_BOOKING_REVIEW_DETAIL,
      payload: {
        reviewId: payload.reviewId,
      },
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: POST_FEEDBACK_BOOKING_REVIEW_FAILED,
    });
  }
}

function* updateBookingReview({ payload }) {
  try {
    yield bookingReviewApi.updateBookingReview(payload);

    yield put({
      type: UPDATE_BOOKING_REVIEW_SUCCESS,
    });

    showSuccess('Chỉnh sửa đánh giá thành công');
    payload.callback?.();

    yield put({
      type: GET_BOOKING_REVIEW_DETAIL,
      payload: {
        reviewId: payload.reviewId,
      },
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_BOOKING_REVIEW_FAILED,
    });
  }
}

function* deleteBookingReview({ payload }) {
  try {
    yield bookingReviewApi.deleteBookingReview(payload.reviewId);

    yield put({
      type: DELETE_BOOKING_REVIEW_SUCCESS,
    });

    showSuccess('Xóa đánh giá thành công');
    payload.callback?.();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: DELETE_BOOKING_REVIEW_FAILED,
    });
  }
}

function* updateFeedbackBookingReview({ payload }) {
  try {
    yield bookingReviewApi.updateFeedbackBookingReview(payload);

    yield put({
      type: UPDATE_FEEDBACK_BOOKING_REVIEW_SUCCESS,
    });

    showSuccess('Chỉnh sửa phản hồi thành công');
    payload.callback?.();

    yield put({
      type: GET_BOOKING_REVIEW_DETAIL,
      payload: {
        reviewId: payload.reviewId,
      },
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_FEEDBACK_BOOKING_REVIEW_FAILED,
    });
  }
}

function* deleteFeedbackBookingReview({ payload }) {
  try {
    yield bookingReviewApi.deleteFeedbackBookingReview(payload.reviewId);

    yield put({
      type: DELETE_FEEDBACK_BOOKING_REVIEW_SUCCESS,
    });

    showSuccess('Xóa phản hồi thành công');
    payload.callback?.();

    yield put({
      type: GET_BOOKING_REVIEW_DETAIL,
      payload: {
        reviewId: payload.reviewId,
      },
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: DELETE_FEEDBACK_BOOKING_REVIEW_FAILED,
    });
  }
}

export default function* locationSaga() {
  yield takeLeading(GET_BOOKING_REVIEW_LIST, getBookingReviewList);
  yield takeLeading(GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW, getReviewOverviewOfBookingReview);
  yield takeLeading(GET_BOOKING_REVIEW_DETAIL, getBookingReviewDetail);
  yield takeLeading(POST_FEEDBACK_BOOKING_REVIEW, postFeedbackBookingReview);
  yield takeLeading(UPDATE_BOOKING_REVIEW, updateBookingReview);
  yield takeLeading(DELETE_BOOKING_REVIEW, deleteBookingReview);
  yield takeLeading(UPDATE_FEEDBACK_BOOKING_REVIEW, updateFeedbackBookingReview);
  yield takeLeading(DELETE_FEEDBACK_BOOKING_REVIEW, deleteFeedbackBookingReview);
}
